<template>
	<div class="eia-stage-indicator"
		:class="classes">
		<template v-if="currentStage">
			<label for="eia-progress-bar">
				{{ this.showStepNumber ? `Step ${displayStageNumber}:` : '' }} {{ currentStage.title || currentStage.header }}
			</label>

			<eia-progress-bar
				:min="0"
				:max="totalStages"
				:value="completedStageIndex ? completedStageIndex + 1 : 0">
			</eia-progress-bar>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'eia-stage-indicator',
	props: {
		currentStage: {
			type: Object,
			required: true,
		},
	},
	data(){
		return {
			showStepNumber: true,
		};
	},
	computed: {
		...mapGetters( 'stages', [ 'totalStages', 'currentStageIndex', 'completedStageIndex' ] ),

		displayStageNumber() {
			return this.currentStageIndex + 1;
		},

		show() {
			return true;
			//return result( this, '$route.meta.showStageIndicator', false );
		},

		classes() {
			return {
				'eia-stage-indicator--show': this.show,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-stage-indicator {
	transform: translate3d( 0, -100%, 0 );
	transition: transform 500ms ease;
	margin-bottom: 24px;

	label {
		display: inline-block;
		margin: 0 0 8px 14px;
		font-size: $text-subheading;
	}

	&--show {
		transform: translate3d( 0, 0, 0 );
	}
}
</style>
